<template>
  <div>
    <swiper ref="mySwiper" :options="swiperOptions" :auto-update="autoUpdate">
      <swiper-slide v-for="(img, index) in images" :key="index">
        <img :src="constructImageURL(img)" class="slide-img" />
        <span class="del-image" @click="$emit('delete', index)" v-if="isShowDelete">
          <v-icon>mdi-delete</v-icon>
        </span>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
      <div class="swiper-button-prev" slot="button-prev"></div>
      <div class="swiper-button-next" slot="button-next"></div>
    </swiper>
  </div>
</template>

<script>
import utils from '../../../utils';
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
// import style (<= Swiper 5.x)
import 'swiper/css/swiper.css'
export default {
  name: 'ImageSwiper',
  components: {
    Swiper,
    SwiperSlide
  },
  props: {
    show: Boolean,
    isShowDelete: Boolean,
    images: Array
  },
  directives: {
    swiper: directive
  },
  data() {
    return {
      autoUpdate: false,
      swiperOptions: {
        slidesPerView: 4,
        spaceBetween: 30,
        pagination: {
          el: '.swiper-pagination'
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
        // Some Swiper option/callback...
      }
    };
  },
  mounted: function() {
    let vm = this
    // fix plugin auto load issue
    setTimeout(function() {
      vm.autoUpdate = true
    }, 1000)
  },
  methods: {
    constructImageURL: function(imageName) {
      return utils.func.constructImageURL(imageName);
    }
  }
};
</script>
<style>
.swiper-pagination-bullet {
  background: #fff!important;
}
.swiper-button-prev, .swiper-button-next {
  color: #3F3FFF!important;
}
.slide-img {
  max-width: 100%;
  max-height: 280px; 
  object-fit: cover;
}
.del-image {
  cursor: pointer;
  position: absolute;
  left: 0;
}
.del-image .v-icon {
  color: red!important;
}
</style>



// WEBPACK FOOTER //
// ImageSwiper.vue?6bb4c584